import { render, staticRenderFns } from "./ItemAddForm.vue?vue&type=template&id=7e656c6d&lang=html&"
import script from "./ItemAddForm.vue?vue&type=script&lang=js&"
export * from "./ItemAddForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports